import React, {useState} from 'react';
import InvitePic from "../../../assets/images/invite.jpg";
import Header from "../../../layouts/Header";
import {getReagents} from "../api/ProfileAPIs";
import {showError} from "../../../utils/toastHelper";
import Loading from "../../../layouts/Loading";

const currencyFormat = Intl.NumberFormat('en-US');
const Reagents = () => {

    const [users , setUsers] = React.useState([]);
    const [loading, setLoading] = useState(true);

    const config = window.APP_CONFIG;

    React.useEffect(() => {
        const match = document.cookie.match(new RegExp('(^| )auth=([^;]+)'));
        const token = match ? match[2] : null;
        if(!token) {
            window.location.replace('/login')
        }
        const fetchReagents = async () => {
            try {
                const data = await getReagents();
                setUsers(data.data);

            } catch (err) {
                showError(err);
            } finally {
                setLoading(false);
            }
        };
        fetchReagents();

    }, []);


    if (loading) return <Loading />;

    return (
        <React.Fragment>

            <Header title='  افراد معرفی شده توسط شما ' hasBack={true} />

            <main className="container rtl ">
                <div className="row px-3 ">
                    <div className="col-12 " >
                        <img src={InvitePic} alt={config.title} className="rounded mx-auto d-block mt-5 w-100" />
                    </div>
                </div>
                {
                    !loading && users.map (user => {
                        return (
                            <div className="row score-row m-3 p-3" key={user.id}>
                                <div className="col-7 text-small-1 fw-bold">
                                    {user.name}
                                    &nbsp;
                                    {user.surname}
                                    <div className='fw-normal text-end text-small-3 text-muted mt-2 ltr '>
                                        {user.mobile}
                                    </div>
                                </div>
                                <div
                                    className="col-5 fw-bold pt-3 text-secondary text-small-3 text-start border-bottom">

                                    {user.date}

                                </div>
                                <div className="col-4 text-small-3 pt-2">
                                     خرید
                                    ماه جاری


                                </div>
                                <div className="col-8 text-small-1 fw-bold text-start  pt-2 text-primary-color">
                                    {

                                            currencyFormat.format(user.sum)
                                    }

                                    &nbsp;
                                    {config.currency}
                                </div>
                                <div className="col-4 mt-2 text-small-3 pt-2">
                                    میزان خرید
                                    کلی


                                </div>
                                <div className="col-8 mt-2 text-small-2 fw-bold text-start  pt-2 text-primary-color">
                                    {

                                            currencyFormat.format(user.sum_last_month)
                                    }

                                    &nbsp;
                                    {config.currency}
                                </div>

                            </div>
                        )
                    })
                }
            </main>

        </React.Fragment>
    );
};

export default Reagents;